var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("ul", { staticClass: "tab-list" }, [
      _c("li", { staticClass: "font-weight800" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("finance.serialnumber")))]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("finance.type")))]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("finance.amountmoney")))]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("finance.proportion")))]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass: "tab-list tab-animate",
        on: {
          mouseenter: function ($event) {
            return _vm.stop()
          },
          mouseleave: function ($event) {
            return _vm.up()
          },
        },
      },
      _vm._l(_vm.tableData, function (item, index) {
        return index < 10
          ? _c("li", { key: index, class: { "animate-up": _vm.animateUp } }, [
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "info", size: "mini", circle: "" } },
                    [_vm._v(_vm._s(index + 1))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              item.cate_id > 0
                ? _c("span", [_vm._v(_vm._s(item.name))])
                : _c("span", [_vm._v(_vm._s(_vm.$t("finance.other")))]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.sum))]),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c("el-progress", {
                    attrs: {
                      "text-inside": true,
                      "stroke-width": 20,
                      percentage: Number(item.ratio),
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e()
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }